import HowToCite from './HowToCite';

globalThis.HowToCiteComponents = {
  HowToCite,
};
